<template>
  <div>
    <section class="content">
      <div class="row">
        <form @submit.prevent="changePassword">
          <div class="col-md-12">
            <div class="box box-info">
              <div class="box-body">
                <!-- calendar group -->
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <label for="actualPsw">Clave Actual</label>
                    </div>
                    <div class="col-md-9">
                      <input class="form-control col-md-12" type="password"  name="actualPsw" id="actualPsw" placeholder="Clave actual" v-model="actualPsw" required/>
                    </div>
                  </div>
                </div>
                <br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <label for="newPsw">Nueva clave</label>
                    </div>
                    <div class="col-md-9">
                      <input class="form-control col-md-12" type="password" name="newPsw" id="newPsw" placeholder="Nueva clave" v-model="newPsw" required />
                    </div>
                  </div>
                </div>
                <br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <label for="newPswRe">Repetir clave</label>
                    </div>
                    <div class="col-md-9">
                      <input class="form-control col-md-12" type="password" name="newPswRe" id="newPswRe" placeholder="Repetir clave" v-model="newPswRe" required />
                    </div>
                  </div>
                </div>
                <br/><br/><br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Cambiar clave</button>
                    </div>
                  </div>
                </div>
                <!-- /input-group -->
              </div>
              <!-- /.box-body -->
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'ChangePsw',
      loading: '',
      actualPsw: '',
      newPsw: '',
      newPswRe: '',
      response: null,
      idUser: this.$store.state.user.idUser
    }
  },
  computed: {
    datetime () {
      return new Date()
    }
  },
  methods: {
    changePassword () {
      this.$confirm('¿Realmente desea cambiar la contraseña?', 'Advertencia', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      })
      .then(() => {
        const {idUser, actualPsw, newPsw, newPswRe} = this

        this.toggleLoading()
        this.resetResponse()
        this.$store.commit('TOGGLE_LOADING')

        api.request('GET', 'api/reestablecerPsw')
        .then(response => {
          this.toggleLoading()
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })

        /* Making API call to authenticate a user */
        api.request('POST', 'api/changePsw', {idUser, actualPsw, newPsw, newPswRe})
          .then(response => {
            this.toggleLoading()
            this.invoices = null

            var data = response.data
            /* Checking if error object was returned from the server */
            if (response.data.error) {
              var errorName = response.data.error.name
              if (errorName) {
                if (errorName === 'InvalidArgumentError') {
                  this.response = 'Los datos suministrados son incorrectos.'
                } else if (errorName === 'NotFoundError') {
                  this.response = 'La factura no se encuentra.'
                } else {
                  this.response = errorName
                }
              } else {
                this.response = data.error
              }
              return
            } else {
              if (data.success) {
                localStorage.removeItem('user')
                this.$store.commit('SET_USER', '')
                this.$store.commit('SET_TOKEN', '')
                this.$router.push('/login')
              }
            }
          })
          .catch(error => {
            this.$store.commit('TOGGLE_LOADING')
            this.invoices = null
            console.log(error)

            this.response = 'Error al conectarse con el servidor, contacte al administrador.'
            this.toggleLoading()
          })
      })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// ChangePsw.vue?5bde334b